import { PencilSimple } from "@phosphor-icons/react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";

import { EditUserForm } from "@/components/User";
import type { ModalProps } from "@/shared.types";
import type { User } from "@/types";
import { Circle, Heading, Modal } from "@/ui";

export const EditUserModal = ({ show, onClose }: ModalProps) => {
  const location = useLocation();
  const user = (location.state as { user: User })?.user;

  if (!user) return null;

  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading="Edit User"
            left={
              <Circle>
                <PencilSimple size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <EditUserForm user={user} onClose={onClose} />
    </Modal>
  );
};
